module.exports = __webpack_public_path__ + "static/media/img7.bcb4e61c.jpg";